/**
 * Quem está emitindo o relatório, para o rodapé.
 *
 * Sai o nome civil completo com o nome de guerra entre parênteses: o documento
 * é oficial e precisa identificar a pessoa em qualquer registro, mas quem lê na
 * operação reconhece o agente pelo nome de guerra.
 *
 * A fonte é o JWT, não o perfil do localStorage: o SignIn salva o perfil com
 * `nome: upperCase(...)` e sem `nome_social` (`src/pages/SignIn/index.js`), o
 * que imprimia "MATHEUS ERICK Mello de Souza" no rodapé. O payload do token traz
 * os dois campos como estão no banco; o perfil fica de reserva para a sessão
 * cujo token não puder ser lido.
 */
export default function nomeDoEmissor(dadosDoToken, perfilSalvo) {
  const usuario = dadosDoToken || perfilSalvo;
  if (!usuario) return '—';

  const civil = [usuario.nome, usuario.sobrenome].filter(Boolean).join(' ').trim();
  const guerra = (usuario.nome_social || '').trim();

  if (!civil) return guerra || '—';
  if (!guerra || guerra === civil) return civil;
  return `${civil} (${guerra})`;
}
